import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import TagManager from 'react-gtm-module';

import { ProtectedRoute } from '../../../components';

import { LiquidezLanding } from '../pages/Landing';
import { CotizacionPreview } from '../../main/pages/CotizacionPreview';
import { CreditProfilingPage } from '../../main/pages/CreditProfilingPage';
import CreateAccountPage from '../../main/pages/CreateAccountPage';
import { MainLayout } from '../../main/layouts';
import { ProfilingProvider } from '../../../context/profiling';
import { CreateAccountProvider } from '../../../context/createAccount';

import {
  AUTH_ROUTE_TYPE,
  CREDIT_PROFILING_COTIZATION_STRATEGY,
  CREDIT_PROFILING_STRATEGY,
  LIQUIDEZ_STRATEGY,
} from '../../../constants';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER,
  events: {
    sendUserInfo: 'userInfo',
  },
  dataLayerName: 'vivienda',
};
TagManager.initialize(tagManagerArgs);

const LiquidezRoutes = () => (
  <div style={{ overflowY: 'auto', height: '100%', background: '#F7FAFD' }}>
    <Routes>
      <Route
        path="/cotizacion"
        element={(
          <ProtectedRoute
            type={AUTH_ROUTE_TYPE}
            redirectPath="/account"
            additionalData={{ authProtected: false }}
          >
            <MainLayout showStepperBar={false}>
              <CotizacionPreview />
            </MainLayout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/cuestionario_perfilamiento"
        element={(
          <ProtectedRoute
            type={AUTH_ROUTE_TYPE}
            redirectPath="/main/consult"
            additionalData={{ authProtected: false }}
          >
            <MainLayout showStepperBar={false}>
              <ProfilingProvider>
                <CreditProfilingPage
                  strategyName={CREDIT_PROFILING_STRATEGY}
                  productStrategy={LIQUIDEZ_STRATEGY}
                />
              </ProfilingProvider>
            </MainLayout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/perfilamiento"
        element={(
          <ProtectedRoute
            type={AUTH_ROUTE_TYPE}
            redirectPath="/main/consult"
            additionalData={{ authProtected: false }}
          >
            <MainLayout showStepperBar={false}>
              <ProfilingProvider>
                <CreditProfilingPage
                  strategyName={CREDIT_PROFILING_COTIZATION_STRATEGY}
                  productStrategy={LIQUIDEZ_STRATEGY}
                />
              </ProfilingProvider>
            </MainLayout>
          </ProtectedRoute>
        )}
      />
      <Route
        path="/account"
        element={(
          <ProtectedRoute
            type={AUTH_ROUTE_TYPE}
            redirectPath="/main/consult"
            additionalData={{ authProtected: false }}
          >
            <MainLayout showStepperBar={false}>
              <CreateAccountProvider>
                <CreateAccountPage productStrategy={LIQUIDEZ_STRATEGY} />
              </CreateAccountProvider>
            </MainLayout>
          </ProtectedRoute>
        )}
      />
      <Route path="/" element={<LiquidezLanding />} />
      <Route path="/*" element={<Navigate to="/liquidez" />} />
    </Routes>
  </div>
);

export default LiquidezRoutes;
